module.exports = __webpack_public_path__ + "img/2d.076efc4f.gif";